import React from 'react';
import { ProductReviewListModel } from 'autogen/swagger/all';
import RatingStars from 'components/generic/ratingStars';
import { rem } from 'modules/helpers/style';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import * as Typography from 'components/__deprecated/typography';
import { useQuickView } from 'components/quickView';
import { ReviewHeadingUnrated } from 'autogen/translation-keys/trans-website-productreview';
import { useTranslation } from 'react-i18next';
import { IProductReviewListModelUrls } from '../shared/types';
import WriteReviewButton from './WriteReviewButton';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    align-items: center;
`;

const RatingContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const BeTheFirst = styled.div`
    font-size: ${rem(20)};
    margin: 30px 0;
    font-weight: bold;
    text-align: center;
`;

const WriteReviewButtonStyled = styled(WriteReviewButton)`
    ${breakpoint.up(sizes.md)} {
        display: flex;
        justify-content: center;
    }
`;

const StyledCaption = styled(Typography.Caption)`
    cursor: pointer;
    margin-top: 8px;
`;

interface INoReviewsProps {
    model: ProductReviewListModel;
}

export const NoReviews = (props: INoReviewsProps): JSX.Element => {
    const { model, ...rest } = props;
    const { complianceHeader } = model;
    const { t } = useTranslation();
    const { toggle: openQuickview } = useQuickView('ReviewComplianceQuickview');
    return (
        <Wrapper {...rest}>
            <RatingContainer>
                {' '}
                <RatingStars rating={0} width="240px" height="45px" />
            </RatingContainer>
            <BeTheFirst>{t(ReviewHeadingUnrated)}</BeTheFirst>
            <WriteReviewButtonStyled model={model} />
            <StyledCaption
                size="sm"
                onClick={() => openQuickview(true)}
                dangerouslySetInnerHTML={{ __html: complianceHeader }}
            />
        </Wrapper>
    );
};

export default NoReviews;
